import { createContext } from 'react'

const confirmationDialogContext = createContext('confirmationDialog')

export default confirmationDialogContext